import CrossIcon from './component'

export default CrossIcon
